"use client";
import React from "react";
import { InputField } from "@/forms/InputField";
import { FormGroup } from "@/forms/FormGroup";
import { useFormContext } from "react-hook-form";
import {
  Tooltip,
  TooltipProps,
  Typography,
} from "@cappelendamm/design-system/react";
import {
  validateBirthdayDay,
  validateBirthdayMonth,
  validateBirthdayYear,
} from "@/forms/customer/validateBirthdate";

export type BirthdateFieldsForm = {
  birth: {
    day: string;
    month: string;
    year: string;
  };
};

type BirthdateFieldsProps = {
  isDisabled?: boolean;
  tooltip?: TooltipProps;
};

export const BirthdateFields = ({
  isDisabled,
  tooltip,
}: BirthdateFieldsProps) => {
  const {
    register,
    formState: { errors },
  } = useFormContext<BirthdateFieldsForm>();

  return (
    <FormGroup isDisabled={isDisabled}>
      <div className="flex w-full justify-between">
        <Typography variant="title-sm" as="legend">
          Fødselsdato
        </Typography>
        {tooltip && <Tooltip {...tooltip} />}
      </div>

      <div className="flex gap-3">
        <InputField
          className="w-[4rem]"
          name="birth.day"
          label="Dag"
          register={register}
          requiredMessage="Du må fylle ut fødselsdag"
          autoComplete="bday-day"
          type="number"
          inputMode="numeric"
          validate={validateBirthdayDay}
          sensitive
        />
        <InputField
          className="w-[4.6rem]"
          name="birth.month"
          label="Måned"
          register={register}
          requiredMessage="Du må fylle ut fødselsmåned"
          autoComplete="bday-month"
          type="number"
          inputMode="numeric"
          validate={validateBirthdayMonth}
          sensitive
        />
        <InputField
          className="w-[5.6rem]"
          name="birth.year"
          label="År"
          register={register}
          requiredMessage="Du må fylle ut fødselsår"
          autoComplete="bday-year"
          type="number"
          inputMode="numeric"
          validate={validateBirthdayYear}
          sensitive
        />
      </div>

      {(errors.birth?.day || errors.birth?.month || errors.birth?.year) && (
        <span className="text-status-error-500">
          {errors.birth.day?.message ||
            errors.birth.month?.message ||
            errors.birth.year?.message}
        </span>
      )}
    </FormGroup>
  );
};
